export const LOCAL_STORAGE = {
  LS_TAB_ID_KEY: 'SOLGARI_TAB_ID',
  LS_SESSION_IS_ACTIVE: 'SESSION_IS_ACTIVE',
  LS_MANUAL_PRESENCE: 'MANUAL_PRESENCE_STATUS',
};
